import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useMediaQuery } from '@mui/material';

export default function AutoCompleteBank({
  options,
  getOptionLabel,
  onChange,
  name,
  value,
  label = 'Seleccionar',
  disabled = false,
  multiple = false,
  size = 'small',
  marginBottom = '10px',
  sx,
  textFieldProps = {},
}) {
  const handleSelect = (event, selectedValue) => {
    onChange(name, selectedValue);
  };
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <Autocomplete
      disablePortal
      name={name}
      options={options}
      getOptionLabel={getOptionLabel}
      value={value}
      onChange={handleSelect}
      disabled={disabled}
      multiple={multiple}
      size={size}
      isOptionEqualToValue={(option, selected) => (
        option?.id === selected?.id || option?.name === selected?.name
      )}
      sx={{
        width: isMobile ? 200 : 300,
        padding: '5px',
        marginBottom,
        ...sx,
      }}
      renderInput={(params) => <TextField {...params} label={label} {...textFieldProps} />}
    />
  );
}
